import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'

import { type DirectContactFormSubmitStatus } from '../../hooks/useDirectContactFormSubmit'
import { directContactFormBuildErrorSubjectLine } from '../../model/directContactFormBuildErrorSubjectLine'
import { DirectContactFormErrorContent } from '../DirectContactFormErrorContent'

import { DirectContactFormHookFormDialogForm } from './DirectContactFormHookFormDialogForm'
import { type DirectContactFormHookFormDialogValues } from './DirectContactFormHookFormDialogModel'
import { type DirectContactFormHookFormFieldsProps } from './DirectContactFormHookFormFields'
import { DirectContactFormSuccessNotification } from './DirectContactFormSuccessNotification'

export const DirectContactFormHookFormDialogBody: FC<{
  configuration: DirectContactFormHookFormFieldsProps['configuration']
  handleSuccessNotificationClose: () => void
  isCancelContract: boolean
  isMutating: boolean
  onSubmit: (values: DirectContactFormHookFormDialogValues) => Promise<void>
  onSuccessClose?: () => void
  submitStatus: DirectContactFormSubmitStatus
}> = ({
  configuration,
  handleSuccessNotificationClose,
  isCancelContract,
  isMutating,
  onSubmit,
  onSuccessClose,
  submitStatus,
}) => {
  const { getValues } = useFormContext<DirectContactFormHookFormDialogValues>()

  if (submitStatus === 'success') {
    return (
      <DirectContactFormSuccessNotification
        handleSuccessClose={onSuccessClose}
        isCancelContract={isCancelContract}
        onClose={handleSuccessNotificationClose}
      />
    )
  }

  if (submitStatus === 'error') {
    const subjectLine = directContactFormBuildErrorSubjectLine(getValues())

    return <DirectContactFormErrorContent subjectLine={subjectLine} />
  }

  return (
    <DirectContactFormHookFormDialogForm
      configuration={configuration}
      isMutating={isMutating}
      onSubmit={onSubmit}
      submitStatus={submitStatus}
    />
  )
}
